<ng-container *transloco="let t; read: 'cooperation'">
  <div class="cooperation p-grid p-nogutter p-jc-center">
    <div class="p-grid p-nogutter wrapper">
      <div class="p-col-12 p-xl-4">
        <div class="p-grid">
          <div class="p-col-12 p-md-6 p-xl-12">
            <h2 class="home-heading">{{ t('header') }}</h2>
            <p
              class="p-pr-3"
              [innerHTML]="t('description')"></p>
          </div>
          <div class="p-col-12 p-md-6 p-xl-12">
            <p class="p-text-bold paddingTop">{{ t('description2') }}</p>
            <p
              *ngIf="!formEnabled"
              class="p-mt-2 p-text-secondary">
              {{ t('formUnavailable') }}
            </p>
          </div>
        </div>
      </div>
      <div class="p-col-12 p-xl-8 cooperation__form">
        <form
          [formGroup]="cooperationFormGroup"
          (focusin)="warmRecaptcha()"
          (ngSubmit)="onSubmit()">
          <div
            class="form-group"
            [class.form-group--unavailable]="!formEnabled">
            <div class="p-d-md-flex">
              <input
                class="cooperationInput"
                type="text"
                pInputText
                placeholder="{{ t('name') }}"
                formControlName="name" />
              <input
                class="cooperationInput"
                type="text"
                pInputText
                placeholder="{{ t('taxNo') }}"
                formControlName="taxNo" />
            </div>
            <div class="p-d-md-flex">
              <input
                class="cooperationInput"
                type="text"
                pInputText
                placeholder="{{ t('phoneNo') }}"
                formControlName="phoneNo" />
              <input
                class="cooperationInput"
                type="text"
                pInputText
                placeholder="{{ t('email') }}"
                formControlName="email" />
            </div>

            <div>
              <textarea
                class="cooperationInput p-mb-4"
                [rows]="2"
                [cols]="30"
                autoResize="autoResize"
                pInputTextarea
                placeholder="{{ t('textMsg') }}"
                formControlName="textMsg"></textarea>
            </div>

            <div class="p-field-checkbox">
              <p-checkbox
                [binary]="true"
                formControlName="agreement1"
                inputId="cooperationCheckbox1"></p-checkbox>
              <label for="cooperationCheckbox1"
                >{{ t('checkbox1Desc1') }}
                <a
                  target="_blank"
                  href="assets/downloads/polityka-prywatnosci.pdf"
                  class="textBlue"
                  >{{ t('checkbox1Desc2') }}</a
                ></label
              >
            </div>

            <div class="p-field-checkbox">
              <p-checkbox
                [binary]="true"
                formControlName="agreement2"
                inputId="cooperationCheckbox2"></p-checkbox>
              <label for="cooperationCheckbox2"
                >{{ t('checkbox2Desc1') }}
                <a
                  target="_blank"
                  class="textBlue"
                  href="assets/downloads/polityka-prywatnosci.pdf"
                  >{{ t('checkbox2Desc2') }}</a
                >
                {{ t('checkbox2Desc3') }}
              </label>
            </div>
            <p
              *ngIf="submitThanks"
              class="form-thanks"
              role="status">
              {{ t('thanks') }}
            </p>
            <div class="p-d-flex p-jc-center p-jc-md-end p-mt-4">
              <button
                type="submit"
                class="buttonYellow"
                [class.buttonYellow--inactive]="submitInactive"
                [disabled]="recaptchaPending || thankYouCooldown"
                style="width: 251px">
                {{ t('button') }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="footer p-grid p-ai-center p-ml-0 p-mr-0">
    <div class="wrapper">
      <a
        target="_blank"
        href="assets/downloads/polityka-prywatnosci.pdf"
        >{{ t('footer') }}</a
      >
    </div>
  </div>
</ng-container>
